import type { RawMessage } from "@/api/messages";

type PenmateSource = {
  id?: string | number | null;
  first_name?: string | null;
  firstName?: string | null;
  last_name?: string | null;
  lastName?: string | null;
  name?: string | null;
  slug?: string | null;
  facility?: string | null;
};

export type PenmateMetricsPayload = {
  penmate_id: string | number | null;
  penmate?: {
    id: string | number;
    first_name: string | null;
    last_name: string | null;
    name: string | null;
    slug: string | null;
    facility: string | null;
  };
};

export const buildPenmateMetricsPayload = (args: {
  penmate?: PenmateSource | null;
  letter?: RawMessage | null;
  penmateId?: string | number | null;
}): PenmateMetricsPayload => {
  const { penmate, letter, penmateId } = args;

  const desiredId =
    (letter as any)?.penmate?.id ??
    (letter as any)?.data?.penmate?.id ??
    (letter as any)?.data?.penmate_id ??
    penmateId ??
    null;

  const src =
    penmate && typeof penmate === "object"
      ? penmate
      : (letter as any)?.penmate && typeof (letter as any)?.penmate === "object"
        ? (letter as any).penmate
        : (letter as any)?.data?.penmate && typeof (letter as any)?.data?.penmate === "object"
          ? (letter as any).data.penmate
          : null;

  if (!src) return { penmate_id: desiredId };

  const srcId = (src as any)?.id ?? desiredId ?? null;
  if (!srcId) return { penmate_id: desiredId };
  if (desiredId != null && (src as any)?.id != null && String(desiredId) !== String((src as any).id)) {
    return { penmate_id: desiredId };
  }

  return {
    penmate_id: srcId,
    penmate: {
      id: srcId,
      first_name: (src as any)?.first_name ?? (src as any)?.firstName ?? null,
      last_name: (src as any)?.last_name ?? (src as any)?.lastName ?? null,
      name: (src as any)?.name ?? null,
      slug: (src as any)?.slug ?? null,
      facility: (src as any)?.facility ?? null,
    },
  };
};
